module.exports = __webpack_public_path__ + "img/progress-dote_filled.967b61ad.svg";